export const tableBlack = '#000000';

export const tableWhite = '#ffffff';

export const tableGrey = '#CCCCCC';

export const lightGrey = '#9B9B9B';

export const tableBorderColor = '#D8D8D8';
